/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as manipulações de casos
 * @author Bene Lemuel Dantas Gondim
 * @file casosReducer.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */
import * as actionTypes from 'actions'
import types from 'utils/actionTypes'

// Estado inicial da sessão no redux
const initialState = {
  casos: [],
  caso: null,
  error: null,
  nomeFuncao: '',
  dados: {
    id: '',
  },
  vestigios: [],
  processandoVestigios: false,
  solicitacoes: [],
  processandoSolicitacoes: false,
  cadaveres: [],
  processandoCadaveres: false,
  periciandos: [],
  processandoPericiandos: false,
  locais: [],
  processandoLocais: false,
}

const casosReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CASOS: {
      return {
        ...state,
        casos: action.casos,
      }
    }

    case types.FETCH_CASO: {
      return {
        ...state,
        caso: action.caso,
      }
    }

    case types.SET_VESTIGIOS_CASO: {
      return {
        ...state,
        vestigios: action.vestigios,
      }
    }
    case types.SET_SOLICITACOES_CASO: {
      return {
        ...state,
        solicitacoes: action.solicitacoes,
      }
    }
    case types.SET_CADAVERES_CASO: {
      return {
        ...state,
        cadaveres: action.cadaveres,
      }
    }
    case types.SET_PERICIANDOS_CASO: {
      return {
        ...state,
        periciandos: action.periciandos,
      }
    }

    case types.SET_LOCAIS_CASO: {
      return {
        ...state,
        locais: action.locais,
      }
    }

    case actionTypes.SET_PROCESSANDO_VESTIGIOS_CASO: {
      return {
        ...state,
        processandoVestigios: action.isProcessandoVestigios,
      }
    }

    case actionTypes.SET_PROCESSANDO_CADAVERES_CASO: {
      return {
        ...state,
        processandoCadaveres: action.isProcessandoCadaveres,
      }
    }

    case actionTypes.SET_PROCESSANDO_PERICIANDOS_CASO: {
      return {
        ...state,
        processandoPericiandos: action.isProcessandoPericiandos,
      }
    }

    case actionTypes.SET_PROCESSANDO_SOLICITACOES_CASO: {
      return {
        ...state,
        processandoSolicitacoes: action.isProcessandoSolicitacoes,
      }
    }

    case actionTypes.SET_PROCESSANDO_LOCAIS_CASO: {
      return {
        ...state,
        processandoLocais: action.isProcessandoLocais,
      }
    }

    case types.FETCH_MEUS_CASOS: {
      return {
        ...state,
        meusCasos: action.meusCasos,
      }
    }

    case types.FETCH_CASOS_DO_SETOR: {
      return {
        ...state,
        casosDoSetor: action.casosDoSetor,
      }
    }

    case actionTypes.SET_PROCESSANDO_FETCH_CASOS: {
      return {
        ...state,
        processandoCasos: action.isProcessandoCasos,
      }
    }

    case actionTypes.CASO_SUCESSO: {
      return {
        ...state,
        nomeFuncao: action.nomeFuncao,
        dados: {
          id: action.dados.id,
        },
      }
    }

    case actionTypes.CASO_ERROR: {
      return {
        ...state,
        error: action.dados,
        nomeFuncao: action.nomeFuncao,
      }
    }

    case actionTypes.VESTIGIO_CASO_SUCESSO: {
      return {
        ...state,
        nomeFuncao: action.nomeFuncao,
        statusHttp: action.statusHttp,
        dados: {
          id: action.dados.id,
        },
      }
    }

    case actionTypes.VESTIGIO_CASO_ERROR: {
      return {
        ...state,
        error: action.dados,
        nomeFuncao: action.nomeFuncao,
      }
    }

    default: {
      return state
    }
  }
}

export default casosReducer
